import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Card, Col, Row } from "react-bootstrap";
import config from "../../../config/config.json";
import { get } from "../../../utils/HttpRequest";

const DeployedVersions = () => {
    const toast = useRef(null);
    const [frontendVersion, setFrontendVersion] = useState(null);
    const [backendVersion, setBackendVersion] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const normalizeVersion = (v) => {
        if (v == null) return "Unknown";
    
        if (typeof v !== "object") {
            return String(v);
        }
    
        const versionValue =
            v.name && v.version
                ? `${v.name} ${v.version}`
                : v.version ?? v.build ?? v.buildId;
    
        if (versionValue != null) {
            return String(versionValue);
        }
    
        try {
            return JSON.stringify(v);
        } catch {
            return "Unknown";
        }
    };
    
    useEffect(() => {
        const fetchVersions = async () => {
            setIsLoading(true);
            setError(null);
    
            try {
                const baseUrl = config.api.url;
    
                const [backendRes, frontendRes] = await Promise.all([
                    get(`${baseUrl}getTrialConfig/backendDeploymentVersion`),
                    get(`${baseUrl}getTrialConfig/frontendDeploymentVersion`)
                ]);
    
                const backendData = backendRes?.data ?? backendRes;
                const frontendData = frontendRes?.data ?? frontendRes;
    
                setBackendVersion(
                    normalizeVersion(backendData?.version ?? backendData)
                );
    
                setFrontendVersion(
                    normalizeVersion(frontendData?.version ?? frontendData)
                );
    
            } catch (err) {
                const message =
                    err?.message || "Failed to fetch deployed versions";
    
                setError(message);
                setFrontendVersion("Unknown");
                setBackendVersion("Unknown");
    
                toast.current?.show?.({
                    severity: "error",
                    summary: "Error",
                    detail: message
                });
    
            } finally {
                setIsLoading(false);
            }
        };
    
        fetchVersions();
    }, []);

    return (
        <div className="app">
            <Toast ref={toast}></Toast>
            <hr />
            <span className="card-title mb-3">Deployed Build Versions</span>
            <Row>
                <Col lg={6}>
                    <p className="px-3" >Frontend: <strong>{frontendVersion}</strong></p>
                </Col>
                <Col lg={6}>
                    <p className="px-3">Backend: <strong>{backendVersion}</strong></p>
                </Col>
            </Row>
            {/* <span className="card-title">Deployed Build Versions</span>{" "}
            <div>
                <div className="mb-2 px-2" >Frontend: <strong>{frontendVersion}</strong></div>
                <div className="mb-2 px-2">Backend: <strong>{backendVersion}</strong></div>
            </div> */}

        </div>
    );
};

export default DeployedVersions;
